// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1h6o{justify-content:center}
._1bsbzwfg{width:2pc}
._1e0c1txw{display:flex}
._80omtlke{cursor:pointer}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/modal/popup-select/dropdownIndicator.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,SAAS;AACpB,WAAW,YAAY;AACvB,WAAW,cAAc","sourcesContent":["._1bah1h6o{justify-content:center}\n._1bsbzwfg{width:2pc}\n._1e0c1txw{display:flex}\n._80omtlke{cursor:pointer}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
